import { render, staticRenderFns } from "./localInfo.vue?vue&type=template&id=14621a36&scoped=true&"
import script from "./localInfo.vue?vue&type=script&lang=js&"
export * from "./localInfo.vue?vue&type=script&lang=js&"
import style0 from "./localInfo.vue?vue&type=style&index=0&id=14621a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14621a36",
  null
  
)

export default component.exports